import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { COMPANY } from "../../lib/constants";

export const CtaBanner = () => {
  return (
    <section
      data-testid="cta-banner"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative rm-card p-10 md:p-16 overflow-hidden">
          <div className="rm-glow-top-right" />
          <div className="relative z-10 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8">
              <div className="rm-overline mb-4">Free first call</div>
              <h3 className="font-display text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-[1.05]">
                Ready to turn ads into real{" "}
                <span className="text-violet-400">business growth</span>?
              </h3>
              <p className="mt-5 text-zinc-400 max-w-2xl">
                Pricing is tailored to your business. Book a free call and
                we'll show you exactly where new customers are slipping past
                you — and the first moves we'd make to grow your business
                faster.
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col gap-3">
              <Link
                to="/contact"
                data-testid="cta-banner-contact"
                className="rm-btn-primary justify-center w-full"
              >
                Get in touch <ArrowUpRight className="h-4 w-4" />
              </Link>
              <a
                href={COMPANY.phoneHref}
                data-testid="cta-banner-call"
                className="rm-btn-secondary justify-center w-full"
              >
                <Phone className="h-4 w-4" /> {COMPANY.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
